import { render, staticRenderFns } from "./AssessmentRiskMitigation.vue?vue&type=template&id=2cbd6028&scoped=true"
import script from "./AssessmentRiskMitigation.vue?vue&type=script&lang=js"
export * from "./AssessmentRiskMitigation.vue?vue&type=script&lang=js"
import style0 from "./AssessmentRiskMitigation.vue?vue&type=style&index=0&id=2cbd6028&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cbd6028",
  null
  
)

export default component.exports